import React, { createContext, useContext } from "react"
import { UseFormReturn, FieldValues } from "react-hook-form"

interface BandEditFormContextValue<T extends FieldValues = FieldValues> {
  form: UseFormReturn<T>
  bandId: number
}

const BandEditFormContext = createContext<BandEditFormContextValue<any> | null>(
  null,
)

export const useBandEditForm = <T extends FieldValues = FieldValues>() => {
  const context = useContext(BandEditFormContext)
  if (!context) {
    throw new Error("useBandEditForm must be used within BandEditFormProvider")
  }
  return context as BandEditFormContextValue<T>
}

interface BandEditFormProviderProps<T extends FieldValues = FieldValues> {
  form: UseFormReturn<T>
  bandId: number
  children: React.ReactNode
}

export const BandEditFormProvider = <T extends FieldValues = FieldValues>({
  form,
  bandId,
  children,
}: BandEditFormProviderProps<T>) => {
  return (
    <BandEditFormContext.Provider value={{ form, bandId } as any}>
      {children}
    </BandEditFormContext.Provider>
  )
}

